<!-- Pagination -->
<nav aria-label="Page navigation" class="mt-2">
  <ul class="pagination d-flex flex-wrap justify-content-end pagination-sm">
    <!-- Change page size -->
    <li class="pagination-text w-100 text-center" *ngIf="paginate.totalRow == 0 && isShowNoRecord">
        {{'form.no_record' | translate}}
    </li>
    <!-- Change page size: tong so ban ghi in dam + "Tong" + select "10/trang" (theo figma, nam ben trai) -->
    <li class="pagination-total" *ngIf="paginate.totalRow > 0 && isShowChangeRecordOfPage">
      <strong class="total-number">{{paginate.totalRow}}</strong>
      <span class="total-label">{{'form.record_total_short' | translate}}</span>
      <mat-form-field class="page-size-select">
        <mat-select (focusout)="(checkFocus = true)" (focus)="commonService.openComboBox(checkFocus, pageSizeSelect)" id="pageSize" #pageSizeSelect
        name="pageSize" [(ngModel)]="paginate.pageSize" (selectionChange)="checkFocus = false; onChangeTotalRecord();">
          <mat-option [value]=10>10/trang</mat-option>
          <mat-option [value]=20>20/trang</mat-option>
          <mat-option [value]=50>50/trang</mat-option>
          <mat-option [value]=100>100/trang</mat-option>
          <mat-option [value]=200>200/trang</mat-option>
        </mat-select>
      </mat-form-field>
    </li>
    <!-- Go to first page -->
    <li class="page-item" *ngIf="paginate.totalRow > 0">
      <button mat-icon-button color="primary" [matTooltip]="'form.record_first_page'| translate"
        [disabled]="paginate.currentPage == 0 || paginate.totalPage < 2"
        (click)="onPageChange($event, (paginate.currentPage == 0 ? 0 : 1))">
        <mat-icon>first_page</mat-icon>
      </button>
    </li>
    <!-- Go to previous page -->
    <li class="page-item" *ngIf="paginate.totalRow > 0">
      <button mat-icon-button color="primary" [matTooltip]="'form.record_previous_page'| translate"
        [disabled]="paginate.currentPage == 0 || paginate.totalPage < 2"
        (click)="onPageChange($event, paginate.currentPage)">
        <mat-icon>chevron_left</mat-icon>
      </button>
    </li>

    <!-- Page(s) render: cua so 5 trang quanh trang hien tai + trang dau/cuoi + dau '...' (theo figma) -->
    <ng-container *ngFor="let item of pageItems">
      <li *ngIf="item === 'ellipsis-left' || item === 'ellipsis-right'" class="page-item ellipsis">
        <button mat-icon-button disabled>
          <mat-icon>more_horiz</mat-icon>
        </button>
      </li>
      <li *ngIf="item !== 'ellipsis-left' && item !== 'ellipsis-right'" class="page-item">
        <button *ngIf="item != paginate.currentPage + 1" color="primary" mat-icon-button
          (click)="onPageChange($event, item)">
          {{item}}
        </button>
        <button mat-mini-fab color="primary" class="font-weight-bold" *ngIf="item == paginate.currentPage + 1"
          (click)="onPageChange($event, item)">
          {{item}}
        </button>
      </li>
    </ng-container>

    <!-- Go to next page -->
    <li class="page-item" *ngIf="paginate.totalRow > 0">
      <button mat-icon-button color="primary" [matTooltip]="'form.record_next_page'| translate"
        [disabled]="paginate.currentPage == paginate.totalPage - 1 || paginate.totalPage < 2"
        (click)="onPageChange($event, paginate.currentPage + 2)">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </li>
    <!-- Go to last page -->
    <li class="page-item" *ngIf="paginate.totalRow > 0">
      <button mat-icon-button color="primary" [matTooltip]="'form.record_last_page'| translate"
        [disabled]="paginate.currentPage == paginate.totalPage - 1 || paginate.totalPage < 2"
        (click)="onPageChange($event, (paginate.currentPage == paginate.totalPage - 1 ? paginate.totalPage + 1 : paginate.totalPage))">
        <mat-icon>last_page</mat-icon>
      </button>
    </li>
    <!-- Go to page: label "Di den" + textbox + arrow button (theo figma: label text rieng, input khung vien, nut vuong moc mui ten) -->
    <li class="page-item pagination-go-to" *ngIf="paginate.totalRow > 0 && paginate.totalPage > 1">
      <label class="go-to-page-label" for="goToPageInput">{{'form.go_to_page' | translate}}</label>
      <input id="goToPageInput" class="go-to-page-input" type="number" name="goToPage" [(ngModel)]="goToPage"
        min="1" [max]="paginate.totalPage" (keydown.enter)="onGoToPage()">
      <button type="button" class="go-to-page-btn" [matTooltip]="'form.go_to_page' | translate"
        aria-label="go to page" (click)="onGoToPage()">
        <mat-icon aria-hidden="true">arrow_forward</mat-icon>
      </button>
    </li>
  </ul>
</nav>
<!-- /Pagination -->
